/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AgendaTensionEditForm_agendaItem$ref: FragmentReference;
declare export opaque type AgendaTensionEditForm_agendaItem$fragmentType: AgendaTensionEditForm_agendaItem$ref;
export type AgendaTensionEditForm_agendaItem = {|
  +id: string,
  +tension: ?{|
    +id: string,
    +body: string,
    +impactedRole: ?{|
      +id: string
    |},
  |},
  +$refType: AgendaTensionEditForm_agendaItem$ref,
|};
export type AgendaTensionEditForm_agendaItem$data = AgendaTensionEditForm_agendaItem;
export type AgendaTensionEditForm_agendaItem$key = {
  +$data?: AgendaTensionEditForm_agendaItem$data,
  +$fragmentRefs: AgendaTensionEditForm_agendaItem$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AgendaTensionEditForm_agendaItem",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Tension",
      "kind": "LinkedField",
      "name": "tension",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "body",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "impactedRole",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AgendaItem",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '2c0e89db92e69654049b97ea26743258';

module.exports = node;
